import React from 'react';
import Big from 'big.js';
import CurrencyNumber from '../../../cmp/CurrencyNumber';
import {FormattedMessage} from 'react-intl';
import FormattedNumber from '../../../cmp/FormattedNumber';

function AggregateDataRow({visits, sales}) {
    const total = visits.length;
    let orders = 0;
    let commission = Big(0);
    visits.forEach((item) => {
        if (item.converted && item.status === "approved") {
            commission = commission.plus(item.affiliate_commission)
            orders += 1;
        }
    })
    const percentage = total > 0 ? Math.round((orders * 100) / total) : 0;
    return (
        <>
            <CardItem title={"Visits"} desc={total}/>
            <CardItem title={"Orders"} desc={<FormattedNumber value={sales?.num_orders || 0} />} />
            <CardItem title={"Conversions"} desc={percentage + "%"}/>
            <CardItem title={"Commissions"} desc={<CurrencyNumber value={sales?.commission || 0}/>}/>
        </>
    );
}


function CardItem({title, desc}) {
    return <div className="card">
        <div className="card-body">
            <small><FormattedMessage id={title}/></small>
            <div style={{fontSize: '2rem'}}>{desc}</div>
        </div>
    </div>
}


export default AggregateDataRow;
